import React from 'react'
import { Field } from 'redux-form';
import { Item, InputPicker, painel } from 'scorpion-core';
import ConvidarPerfil from '../../../../admin/ConsultaPerfisAdmin/componentes/ConvidarPerfil';


function componentRelEspelho(comp, dados) {
    return painel([
        [{ style: "cellTitulo", text: comp.label }], [{ style: "cellValor", text: dados[comp.field] }]
    ], { widths: ['*'] })

}
function toStringItemFunc(item, index) {
    return item;
}

function component(item, propsG) {
        return (<ConvidarPerfil name={item.field} label={item.label} {...item.propsadd}/>)
  
   
}

const modelo = {
    field: "responsavel",
    label: "Responsavel",
    typeComponente: "AtribuirPerfil",
}

const comp = {
    typeComponente: "AtribuirPerfil",
    configView: {
        nome: "Seletor Perfil",
        modelo,             
    },
    componentRelEspelho,
    component
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/AtribuirPerfil/index.js